import { Button, DropDownButton } from '@progress/kendo-react-buttons'

import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useState
} from 'react'

import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from '@progress/kendo-react-layout'
import { useDhProcessoStore } from '../../stores/dhProcesso'

import PesquisarProcessoForm from './PesquisarProcessoForm'
import PesquisarPatrimonioForm from './PesquisarPatrimonioForm'
import PesquisarDemarcacaoForm from './PesquisarDemarcacaoForm'
import { useDhPatrimonioStore } from '../../stores/dhPatrimonio'
import { useDhDemarcacaoStore } from '../../stores/dhDemarcacao'
import { _export, _exportPdf, b64toBlob, exportPDFWithMethod, exportToCSV, get, handleDownload, hasPermission, post, setDemarcacaoSelected, setPatrimonioSelected, setProcessoSelected, updateColumnsGrid } from '../../services/utils'
import { useDemarcacaoStore } from '../../stores/demarcacao'
import { usePatrimonioStore } from '../../stores/patrimonio'
import { AUTH_LOCALSTORAGE, clearLayers, DEMARCACAO_MODULE_NAME, GET_DEMARCACOES_TO_EXPORT, GET_DH_DEMARCACAO_SHAPEFILE, GET_DH_PATRIMONIO_SHAPEFILE, GET_DH_PROCESSO_SHAPEFILE, GET_LIST_RESULTS_AUTOS, GET_LIST_RESULTS_AUTOS_VERTICES, GET_LIST_RESULTS_DH_PROCESSO, GET_PATRIMONIOS_TO_EXPORT, GET_PROCESSOS_TO_EXPORT, LAYER_INDEX_DH_PROCESSO, OPERATIONAL_LAYER, PATRIMONIO_MODULE_NAME, PERMISSION_DOMINIO_HIDRICO_PERFIL_BASICO, PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO, PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA, PERMISSION_DOMINIO_HIDRICO_PERFIL_INTERMEDIO_LEITURA, PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL, PERMISSION_LISTAR_DH_DEMARCACAO, PERMISSION_LISTAR_DH_PATRIMONIO, PESQUISAR_ENTIDADEBYUSER, PROCESSO_MODULE_NAME, RECORDS_LIMIT, RELATORIO_MERGE_PROCESSO, URL_AJUDA_DOMINIO_HIDRICO_DEMARCACAO, URL_AJUDA_DOMINIO_HIDRICO_PATRIMONIO, URL_AJUDA_DOMINIO_HIDRICO_PROCESSO } from '../../utils/constants'
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import SessionStorageService from '../../services/SessionStorageService'
import ResultadoProcessoForm from './ResultadoProcessoForm'
import { CSVLink } from 'react-csv'
import MaximizeButton from '../common/MaximizeButton'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import ResultadoPatrimonioForm from './ResultadoPatrimonioForm'
import ResultadoDemarcacaoForm from './ResultadoDemarcacaoForm'

import styles from '../../styles/dominiohidrico/DominioHidrico.module.scss'
import commonStyles from '../../styles/common/Common.module.scss'
import clsx from 'clsx'
import { useCommonStore } from '../../stores/common'
import useClearMap from '../../hooks/useClearMap'

type RegistoButtonLabel =
  | 'Novo processo'
  | 'Novo património'
  | 'Nova demarcação'

type Props = {
  onCloseClick: (
    e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
  ) => void | undefined,
  setShowRegistoPatrimonio?: Dispatch<SetStateAction<boolean>>
  setShowRegistarDemarcacao?: Dispatch<SetStateAction<boolean>>
  setShowResults: Dispatch<SetStateAction<boolean>>
  setShowRegistarProcessoForm?: Dispatch<SetStateAction<boolean>>


}

export default function PesquisarDominioHidricoTabs({ onCloseClick, setShowRegistoPatrimonio, setShowRegistarDemarcacao, setShowRegistarProcessoForm, setShowResults }: Props) {
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelected] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedDominioHidricoPai');
    return storedValue ? storedValue : 0;
  });

  const [selectedProcesso, setSelectedProcesso] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedProcesso');
    return storedValue ? storedValue : 0;
  });

  const [selectedPatriminio, setSelectedPatrimonio] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedPatriminio');
    return storedValue ? storedValue : 0;
  });

  const [selectedDemarcacao, setSelectedDemarcacao] = useState<number>(() => {
    const storedValue = SessionStorageService.getItem('selectedDemarcacao');
    return storedValue ? storedValue : 0;
  });

  const [secondShowTab, setSecondShowTab] =useState<boolean>(
    () => {
      const storedValue = SessionStorageService.getItem('secondShowTabDh');
      return storedValue ? true : false;
    });


  const [newRegistoLabel, setNewRegistoLabel] = useState<string>('Novo processo')
  const [isMaximized, setIsMaximized] = useState(false)
  const selectProcessoResult = useDhProcessoStore((state) => state.selectDhProcessoResult)
  const selectPatrimonioResult = useDhPatrimonioStore((state) => state.selectDhPatrimonioResult)
  const selectDemarcacaoResult = useDhDemarcacaoStore((state) => state.selectDhDemarcacaoResult)
  const [showExportButtons, setShowExportButtons] = useState(true);

  const getShapeFileProcesso = async (data: any) =>
    await post<any, any>(`${GET_DH_PROCESSO_SHAPEFILE}`, data)
  const getShapeFilePatrimonio = async (data: any) =>
    await post<any, any>(`${GET_DH_PATRIMONIO_SHAPEFILE}`, data)
  const getShapeFileDemarcacao = async (data: any) =>
    await post<any, any>(`${GET_DH_DEMARCACAO_SHAPEFILE}`, data)

  const getProcessoPorIds = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_DH_PROCESSO}`, data)

  const getEntidadeByUser = async (data: any) => await get<any, any>(`${PESQUISAR_ENTIDADEBYUSER}/` + data)
    const consultarProcessoToExport = async(data: any) => await post<any, any>(`${GET_PROCESSOS_TO_EXPORT}`, data)
    const consultarPatrimoniosToExport = async(data: any) => await post<any, any>(`${GET_PATRIMONIOS_TO_EXPORT}`, data)
    const consultarDemarcacoesToExport = async(data: any) => await post<any, any>(`${GET_DEMARCACOES_TO_EXPORT}`, data)
    
  
  const getListAutosVertices = async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_AUTOS_VERTICES}`, data)

  const getListAutos= async (data: any) =>
    await post<any, any>(`${GET_LIST_RESULTS_AUTOS}`, data)

  const relatorioProcessoMerge = async (data: any) =>
    await post<any, any>(`${RELATORIO_MERGE_PROCESSO}`, data)

  const [someNewButton, setSomeNewButtom] = useState(false);
  const PROCESSO = 0;
  const PATRIMONIO = 1;
  const DEMARCACAO = 2;


  const selectProcessoResultId = useDhProcessoStore((state) => state.selectDhProcessoResultId)
  const selectDemarcacaoResultId = useDemarcacaoStore((state) => state.selectDemarcacaoResultId)
  const selectPatrimonioResultId = usePatrimonioStore((state) => state.selectPatrimonioResultId)
  const [seePatrimonio, setSeePatrimonio] = useState(false);
  const [seeProcesso, setSeeProcesso] = useState(false);
  const [seeDemarcacao, setSeeDemarcacao] = useState(false);
  const [showResultadoProcesso, setShowResultadoProcesso] = useState(true)
  const [showResultadoPatrimonio, setShowResultadoPatrimonio] = useState(true)
  const [showResultadoDemarcacao, setShowResultadoDemarcacao] = useState(true)

  const canSeeDominioHidrico = hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_BASICO) ||
                            hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) ||
                            hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) ||
                            hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL) 

  const canSeeDominioHidricoEdit = hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL);

  const [columsDocumentsProcesso, setColumsDocumentsProcesso] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "processo_id", width: 180, title: "ID Processo", show: true },
      { field: "data_publicacao", width: 180, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 180, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 180, title: "Título", show: true },
      { field: "autores", width: 180, title: "Autor", show: true },
      { field: "entidade.nome", width: 180, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const [columsDocumentsPatrimonio, setColumsDocumentsPatrimonio] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "patrimonio_id", width: 180, title: "ID Patrimonio", show: true },
      { field: "data_publicacao", width: 180, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 180, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 180, title: "Título", show: true },
      { field: "autores", width: 180, title: "Autor", show: true },
      { field: "entidade.nome", width: 180, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const [columsDocumentsDemarcacao, setColumsDocumentsDemarcacao] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "demarcacao_id", width: 180, title: "ID Demarcação", show: true },
      { field: "data_publicacao", width: 180, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 180, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 180, title: "Título", show: true },
      { field: "autores", width: 180, title: "Autor", show: true },
      { field: "entidade.nome", width: 180, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const [columsProcessoInicio, setColumsProcessoInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
    columns:[
        { field: "id", title: "ID", show: true, width: 70 },
        { field: "tipo_processo", title: "Tipo de processo", show: true, width: 200 },
        { field: "com_auto_delimitacao", title: "Com auto de delimitação", show: false, width: 220 },
        { field: "fase_procedimento_delimitacao", title: "Fase de procedimento", show: false, width: 200 },
        { field: "tipo_sentenca", title: "Sentença", show: false, width: 200 },
        { field: "tipo_decisao_final", title: "Decisão final", show: false, width: 200 },
        // { field: "tipo_situacao_notificacao", title: "Tipo situação notificação", show: false, width: 230 },
        { field: "condicionantes_processo", title: "Condicionantes ao procedimento de delimitação", show: false, width: 365 },
        { field: "tipo_acao_judicial", title: "Tipo de ação judicial", show: false, width: 200 },
        { field: "tipo_aquisicao", title: "Tipo de aquisição", show: false, width: 200 },
        { field: "tipo_iniciativa", title: "Tipo de iniciativa", show:false, width: 200 },
        { field: "def_licenciamento", title: "Deferimento de licenciamento", show: false, width: 300 },
        { field: "tipo_acao_reconhecimento", title: "Tipo acao reconhecimento", show: false, width: 270 },
        { field: "reconhecimento_propriedade_privada", title: "Reconhecimento de propriedade privada", show: false, width: 300 },
        { field: "np_filedoc", title: "Nº Processo APA", show: true, width: 170 },
        { field: "lugar", title: "Lugar toponímico ", show: true, width: 170 },
        { field: "requerente", title: "Requerente", show: true, width: 170 },
        { field: "assunto", title: "Assunto", show: true, width: 170 },
        { field: "representante", title: "Representante na comissão delimitação", show: false, width: 300 },
        { field: "utilizador", title: "Técnico de registo", show: false, width: 220 },
        { field: "estado_processo", title: "Estado do processo", show: true, width: 180 },
        { field: "distritos", title: "Distrito", show: false, width: 190 },
        { field: "np_cdpm", title: "Nº Processo CDPM", show: false, width: 190},
        { field: "np_ent_por", title: "Nº Proc ent. portuária", show: false, width: 190},
        { field: "np_mp", title: "Nº Proc administrativo (MP)", show: false, width: 190},
        { field: "np_comum", title: "Nº Proc tribunal", show: false, width: 190},
        { field: "entidade", title: "Entidade", show: false, width: 190},
        { field: "recurso", title: "Recurso", show: false, width: 190},
        { field: "nm_registo_sgd", title: "Nº Registo SGD", show: false, width: 190},
        { field: "np_legado", title: "Nº Processo legado", show: false, width: 190},
        { field: "concelhos", title: "Concelho", show: true, width: 190 },
        { field: "freguesias", title: "Freguesia", show: false, width: 190 },
        { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
        { field: "arhs", title: "ARH", show: false, width: 190 },
        { field: "capitanias", title: "Capitania", show: false, width: 190 },
        { field: "nuts1", title: "NUTS I", show: false, width: 190 },
        { field: "nuts2", title: "NUTS II", show: false, width: 190 },
        { field: "nuts3", title: "NUTS III", show: false, width: 190 },
      ]
  })

  const [columsProcessoBasicoInicio, setColumsProcessoBasicoInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
    columns:[
        { field: "id", title: "ID", show: true, width: 70 },
        { field: "tipo_processo", title: "Tipo de processo", show: true, width: 200 },
        { field: "estado_processo", title: "Estado do processo", show: true, width: 180 },
         { field: "lugar", title: "Lugar toponímico ", show: true, width: 170 },
         { field: "concelhos", title: "Concelho", show: true, width: 190 },
        { field: "np_filedoc", title: "Nº Processo APA", show: true, width: 170 },
        { field: "tipo_decisao_final", title: "Decisão final", show: false, width: 200 },
        { field: "tipo_acao_judicial", title: "Tipo de ação judicial", show: false, width: 200 },
        { field: "tipo_aquisicao", title: "Tipo de aquisição", show: false, width: 200 },
      ]
  })

  const [columsPatrimonioInicio, setColumsPatrimonioInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
    columns:[
        { field: "id", title: "ID", show: true, width: 70 },
        { field: "lugar", title: "Lugar toponímico", show: true, width: 190 },
        { field: "designacao", title: "Designação", show: false, width: 180 },
        { field: "diploma", title: "Diploma legal", show: true, width: 190 },
        { field: "utilizador", title: "Técnico de registo", show: false, width: 220 },
        { field: "data_registo_formatted", title: "Data de registo", show: false, width: 190 },
        { field: "distritos", title: "Distrito", show: false, width: 190 },
        { field: "concelhos", title: "Concelho", show: true, width: 190 },
        { field: "freguesias", title: "Freguesia", show: false, width: 190 },
        { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
        { field: "arhs", title: "ARH", show: false, width: 190 },
        { field: "capitanias", title: "Capitania", show: false, width: 190 },
        { field: "nuts1", title: "NUTS I", show: false, width: 190 },
        { field: "nuts2", title: "NUTS II", show: false, width: 190 },
        { field: "nuts3", title: "NUTS III", show: false, width: 190 },
        { field: "filedoc_cod", title: "Nº Processo APA", show: false, width: 190}
    ]
  })

  const [columsDemarcacaoInicio, setColumsDemarcacaoInicio]=useState<{columns:{field:string, title:string, width:number|string, show:boolean}[]}>({
    columns:[
        { field: "id", title: "ID", show: true, width: 70 },
        { field: "tipo_li", title: "Tipo de linha", show: true, width: 180 },
        { field: "designacao", title: "Designação", show: true, width: 180 },
        { field: "data_registo", title: "Data de registo", show: false, width: 190 },
        { field: "distritos", title: "Distrito", show: false, width: 190 },
        { field: "concelhos", title: "Concelho", show: false, width: 190 },
        { field: "freguesias", title: "Freguesia", show: false, width: 190 },
        { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
        { field: "arhs", title: "ARH", show: true, width: 190 },
        { field: "capitanias", title: "Capitania", show: false, width: 190 },
        { field: "nuts1", title: "NUTS I", show: false, width: 190 },
        { field: "nuts2", title: "NUTS II", show: false, width: 190 },
        { field: "nuts3", title: "NUTS III", show: false, width: 190 },
    ]
  })

  const columnsProcessoBasicoOrdered =  {columns: columsProcessoBasicoInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 
  const columnsProcessoOrdered =  {columns: columsProcessoInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 
  const columnsPatrimonioOrdered =  {columns: columsPatrimonioInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 
  const columnsDemarcacaoOrdered =  {columns: columsDemarcacaoInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 


  const [columnsProcesso, setColumnsProcesso] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsProcesso');
    if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
      return storedValue ?? columnsProcessoOrdered;
    } else {
      return storedValue ?? columnsProcessoBasicoOrdered;
    }
  });

  const [columnsProcessoGrid, setColumnsProcessoGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsProcessoGrid');
    if (storedValue) {
      return storedValue;
    } else {
      if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
        return columsProcessoInicio;
      } else {
        return columsProcessoBasicoInicio;
      }
    }
    // return storedValue ?? columsProcessoInicio;
  });

   const [columnsPatrimonio, setColumnsPatrimonio] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsPatrimonio');
    return storedValue ?? columnsPatrimonioOrdered;
  });

  const [columnsPatrimonioGrid, setColumnsPatrimonioGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsPatrimonioGrid');
    return storedValue ?? columsPatrimonioInicio;
  });

  const [columnsDemarcacao, setColumnsDemarcacao] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsDemarcacao');
    return storedValue ?? columnsDemarcacaoOrdered;
  });

  const [columnsDemarcacaoGrid, setColumnsDemarcacaoGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsDemarcacaoGrid');
    return storedValue ?? columsDemarcacaoInicio;
  });

  useEffect(() => {  
    SessionStorageService.setItem("columnsProcesso", columnsProcesso);
    updateColumnsGrid(columnsProcesso, columnsProcessoGrid, setColumnsProcessoGrid)
  }, [columnsProcesso])

  useEffect(() => {
    SessionStorageService.setItem("columnsProcessoGrid", columnsProcessoGrid)
  }, [columnsProcessoGrid])

  useEffect(() => {
    SessionStorageService.setItem("columnsPatrimonioGrid", columnsPatrimonioGrid)
  }, [columnsPatrimonioGrid])

  useEffect(() => {
    SessionStorageService.setItem("columnsPatrimonio", columnsPatrimonio);
    updateColumnsGrid(columnsPatrimonio, columnsPatrimonioGrid, setColumnsPatrimonioGrid)
  }, [columnsPatrimonio])

  useEffect(() => {
    SessionStorageService.setItem("columnsDemarcacao", columnsDemarcacao)
    updateColumnsGrid(columnsDemarcacao, columnsDemarcacaoGrid, setColumnsDemarcacaoGrid)
  }, [columnsDemarcacao])

  useEffect(() => {
    SessionStorageService.setItem("columnsDemarcacaoGrid", columnsDemarcacaoGrid)
  }, [columnsDemarcacaoGrid])

  const [columns, setColumns] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsDhTabs');
    return storedValue ?? {columns: {}};
  });

  useEffect(() => {
    SessionStorageService.setItem("secondShowTabDh", secondShowTab)
  }, [secondShowTab])

  const [columnsPrint, setColumnsPrint] = useState<any>();
  const REGISTOS = 0
  const DOCUMENTOS = 1

  useEffect(() => {
    SessionStorageService.setItem('selectedDominioHidricoPai', selected);
  }, [selected]);

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSecondShowTab(true);
    if (e.selected == PROCESSO) {
      setNewRegistoLabel("Novo processo");
      if (!SessionStorageService.getItem("columnsProcesso")) {
        if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
          setColumnsProcesso(columnsProcessoOrdered)
        } else {
          setColumnsProcesso(columnsProcessoBasicoOrdered)
        }
      }
      if (!SessionStorageService.getItem("columnsProcessoGrid")) {
        if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
          setColumnsProcessoGrid(columsProcessoInicio) 
        } else {
          setColumnsProcessoGrid(columsProcessoBasicoInicio)
        }
      } else {
        setColumnsProcessoGrid(SessionStorageService.getItem("columnsProcessoGrid"))
      }
      setColumnsPrint(columnsProcessoGrid)
      setSomeNewButtom(false)
    }
    else if (e.selected == PATRIMONIO ) {
      setNewRegistoLabel("Novo património");
      if (!SessionStorageService.getItem("columnsPatrimonio")) {
        setColumnsPatrimonio(columnsPatrimonioOrdered)
      }
      if (!SessionStorageService.getItem("columnsPatrimonioGrid")) {
        setColumnsPatrimonioGrid(columsPatrimonioInicio)
      } else {
        setColumnsPatrimonioGrid(SessionStorageService.getItem("columnsPatrimonioGrid"));
      }
      setColumnsPrint(columnsPatrimonioGrid)
      setSomeNewButtom(false);
    }
    else if (e.selected == DEMARCACAO  ) {
      setNewRegistoLabel("Nova demarcação");
      if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
        setSomeNewButtom(false)
      } else {
        setSomeNewButtom(true)
      }
      if (!SessionStorageService.getItem("columnsDemarcacao")) {
        setColumnsDemarcacao(columnsDemarcacaoOrdered)
      }
      if (!SessionStorageService.getItem("columnsDemaracaoGrid")) {
        setColumnsDemarcacaoGrid(columsDemarcacaoInicio)
      } else {
        setColumnsDemarcacaoGrid(SessionStorageService.getItem("columnsDemaracaoGrid"))
      }
      setColumnsPrint(columnsDemarcacao)
    }
    setSelected(e.selected)
    SessionStorageService.setItem("selectedDominioHidricoPai", e.selected);
  }

  useEffect(() => {
    setSecondShowTab(false);
  }, [])

  const [clearMap] = useClearMap();
  const handleNewRegistoClick = useCallback(() => {
    if (selected === DEMARCACAO) {
      setDemarcacaoSelected(undefined);
      selectDemarcacaoResult(undefined);
      setShowResults(false)
      sessionStorage.setItem('novaDemarcacao', 'true')
      clearMap(clearLayers["CLEAR_LAYERS_DEMARCACAO"]);
      const loggedUser = JSON.parse(
        localStorage.getItem(AUTH_LOCALSTORAGE) ?? '{}'
      )
      setDemarcacaoSelected({ tecnicoRegisto: loggedUser?.user?.name })
      if (setShowRegistarDemarcacao)
        setShowRegistarDemarcacao(true)
    }

    if (selected === PATRIMONIO) {
      setPatrimonioSelected(undefined);
      selectPatrimonioResult(undefined);
      setShowResults(false)
      sessionStorage.setItem('novoPatrimonio', 'true')
      clearMap(clearLayers["CLEAR_LAYERS_PATRIMONIO"]);
      if (setShowRegistoPatrimonio)
        setShowRegistoPatrimonio(true)

    }

    if (selected === PROCESSO) {
      selectProcessoResult(undefined);
      setProcessoSelected(undefined);
      setShowResults(false);
      selectProcessoResultId(undefined)
      sessionStorage.setItem('novoProcesso', 'true')
      SessionStorageService.removeItem("gridDataPareceres");
      
      clearMap(clearLayers["CLEAR_LAYERS_PROCESSOS"]);
      const iframe: any = document.getElementById('iframeGeoPortal')
      
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDhAutosClearLayers', value: "true" },
        '*'
      )
  
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDhAutosVerticesClearLayers', value: "true" },
        '*'
      )
      
      iframe.contentWindow?.postMessage(
        {
          type: 'SiarlCoordenadaBoxClose',
          value: 'true',
        },
        '*'
      )
  
      // if(pontoAtivo){
      //   DesativarSelecaoPonto()
      // }
  
      iframe.contentWindow?.postMessage(
        { type: 'SiarlRemoveSelection', value: 'true' },
        '*'
      )
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDhAutosClearLayers', value: 'true' },
        '*'
      )
      iframe.contentWindow?.postMessage(
        { type: 'SiarlDhAutosClearLayers', value: 'true' },
        '*'
      )

      if (setShowRegistarProcessoForm) 
      setShowRegistarProcessoForm(true);

    }
  }, [newRegistoLabel])

  useEffect(() => {
    switch(selected) {
      case PROCESSO :
        if (!SessionStorageService.getItem("columnsProcesso")) {
          if (hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_EDICAO) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_COMPLETO_LEITURA) || hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL)) {
            setColumnsProcesso(columnsProcessoOrdered) 
          } else {
            setColumnsProcesso(columnsProcessoBasicoOrdered);
          }
        }
        setColumnsPrint(columnsProcessoGrid)
        setNewRegistoLabel('Novo Processo')
      break;
      case PATRIMONIO : 
        if (!SessionStorageService.getItem("columnsPatrimonio")) {
          setColumnsPatrimonio(columnsPatrimonioOrdered)
        }
        setColumnsPrint(columnsPatrimonioGrid)
        setNewRegistoLabel('Novo Património')
      break;
      case DEMARCACAO: 
        if (!SessionStorageService.getItem("columnsDemarcacao")) {
          setColumnsDemarcacao(columnsDemarcacaoOrdered)
        }
        setColumnsPrint(columnsDemarcacaoGrid);
        setNewRegistoLabel('Nova Demarcação');
      break;
    }
  }, [])

  useEffect(() => {
    SessionStorageService.setItem("selectedProcesso", selectedProcesso);
  },[selectedProcesso])

  useEffect(() => {
    SessionStorageService.setItem("selectedPatriminio", selectedPatriminio);
  },[selectedPatriminio])

  useEffect(() => {
    SessionStorageService.setItem("selectedDemarcacao", selectedDemarcacao);
  },[selectedDemarcacao])

  const handleMessageEvent = useCallback((event: MessageEvent) => {
    if (event.data.type == "subSelectedDhChange") {
      const selectedValue = SessionStorageService.getItem("selectedDominioHidricoPai");
      switch(selectedValue) {
        case PROCESSO : 
          if (event.data.value == REGISTOS) {
            setColumns(columnsProcesso);
            setColumnsPrint(columnsProcesso)
            setSelectedProcesso(REGISTOS)
            setShowExportButtons(true);
          } 
          else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsProcesso)
            setSelectedProcesso(DOCUMENTOS)
            setShowExportButtons(false);
          }
        break;
        case PATRIMONIO : 
          if (event.data.value == REGISTOS) {
            setColumns(columnsPatrimonio);
            setColumnsPrint(columnsPatrimonio)
            setSelectedPatrimonio(REGISTOS)
            setShowExportButtons(true);
          } 
          else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsPatrimonio)
            setSelectedPatrimonio(DOCUMENTOS)
            setShowExportButtons(false)
          }
        break;
        case DEMARCACAO:
          if (event.data.value == REGISTOS) {
            setColumns(columnsDemarcacao)
            setColumnsPrint(columnsDemarcacao)
            setSelectedDemarcacao(REGISTOS)
            setShowExportButtons(true)
          } else if (event.data.value == DOCUMENTOS) {
            setColumnsPrint(columnsDemarcacao)
            setSelectedDemarcacao(DOCUMENTOS)
            setShowExportButtons(false);
          }
        break
      }
    }
    else if (event.data.type == "processoColumnsChange") {
      setColumnsProcesso(event.data.value);
    }
    else if (event.data.type == "patrimonioColumnsChange") {
      setColumnsPatrimonio(event.data.value);
    }
    else if (event.data.type == "demarcacaoColumnsChange") {
      setColumnsDemarcacao(event.data.value);
    }
  }, [])

  useEffect(() => {
    window.addEventListener('message', handleMessageEvent, false)

    return () => {
      window.removeEventListener('message', handleMessageEvent, false)
    }
  }, [handleMessageEvent])

  useEffect(() => {
    setSeeDemarcacao(canSeeDominioHidrico)
    setSeePatrimonio(canSeeDominioHidrico)
    setSeeProcesso(canSeeDominioHidrico)
  }, []);

  const openAjuda = () => {
    if (SessionStorageService.getItem("DominioHidricoTipoPesquisa")) {
      const tipoPesquisaDH = SessionStorageService.getItem("DominioHidricoTipoPesquisa")
      if (tipoPesquisaDH == PROCESSO_MODULE_NAME) {
        window.open(URL_AJUDA_DOMINIO_HIDRICO_PROCESSO, "_blank")
      } else if (tipoPesquisaDH == PATRIMONIO_MODULE_NAME) {
        window.open(URL_AJUDA_DOMINIO_HIDRICO_PATRIMONIO, "_blank")
      } else if (tipoPesquisaDH == DEMARCACAO_MODULE_NAME) {
        window.open(URL_AJUDA_DOMINIO_HIDRICO_DEMARCACAO, "_blank")
      }

    }
  }

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);

  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

  };

  useEffect(() => {
    SessionStorageService.setItem("columnsDhTabs", columns)
  }, [columns])
  
  const removeSessionPatrimonio = () => {

    SessionStorageService.removeItem("lastSearchPatrimonio")
  };

  const removeSessionDemarcacao = () => {

    SessionStorageService.removeItem("lastSearchDemarcacao")
  };
  const optionsMais = [
    {
      key: 'novoRegisto',
      text: newRegistoLabel,
      elementType: 'button',
      className: 'icon-siarl icon-registar btnIconRegistar'
    }
  ]

const optionsExportarNormal = [
      {
          key: 'ExportarListaResultadosExcel',
          text: 'Excel',
      },
      {
        key: 'ExportarListaResultadosShapeFile',
        text: 'Shapefile',
      },    {
        key: 'ExportarTodasFichas',
        text: 'Fichas',
      },
  ]
  const optionsExportarFullPermission = [
    {
        key: 'ExportarListaResultadosExcel',
        text: 'Excel',
    },
    {
      key: 'ExportarListaResultadosCsvTotal',
      text: 'CSV Total',
  },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },    {
      key: 'ExportarTodasFichas',
      text: 'Fichas',
    },
]
  const [optionsExportar, setOptionsExportar] = useState<any> (
      hasPermission(PERMISSION_DOMINIO_HIDRICO_PERFIL_TOTAL) ? optionsExportarFullPermission : optionsExportarNormal);
const exportPDF = () => {
  _exportPdf.save();
};

const exportExcel = () => {
  _export.save();
};


const onItemClickExportar = async (event: any) => {
  if (event.item.key == 'ExportarListaResultadosExcel') {
    exportExcel();
  }
  if (event.item.key == 'ExportarListaResultadosCsvTotal') {
    if (selected == PROCESSO) {
      const objToSearch = SessionStorageService.getItem("lastSearchProcessos");
      postMessage({ type: 'showLoader' }, '*');
      const result: any = await consultarProcessoToExport(objToSearch);
      exportToCSV(result, 'DHProcessos', ';');
      postMessage({ type: 'hideLoader' }, '*');
    }
    else if (selected == PATRIMONIO) {
      const objToSearch = SessionStorageService.getItem("lastSearchPatrimonio");
      postMessage({ type: 'showLoader' }, '*');
      const result: any = await consultarPatrimoniosToExport(objToSearch);
      exportToCSV(result, 'DHPatrimonios', ';');
      postMessage({ type: 'hideLoader' }, '*');
    }
    else if (selected == DEMARCACAO) {
      const objToSearch = SessionStorageService.getItem("lastSearchDemarcacao");
      postMessage({ type: 'showLoader' }, '*');
      const result: any = await consultarDemarcacoesToExport(objToSearch);
      exportToCSV(result, 'DHDemarcacoes', ';');
      postMessage({ type: 'hideLoader' }, '*');
    }
  }
  if(event.item.key == "ExportarTodasFichas"){
    onItemClickExportarFichasProcesso();
  }
  if(event.item.key == "ExportarListaResultadosPdf"){
    exportPDF();
  }
  else if (event.item.key == "ExportarListaResultadosShapeFile") {
    
    let filePath = '';
    let results = [];
    
    if (selected == PROCESSO) {
      
      results = JSON.parse(
        SessionStorageService.getItem('resultadoProcessosPesquisa') ?? ''
      )
    }
    else if (selected == PATRIMONIO) {
      results = JSON.parse(
        SessionStorageService.getItem('resultadoPatrimoniosPesquisa') ?? ''
      )
    } else if (selected == DEMARCACAO) {
      results = JSON.parse(
        SessionStorageService.getItem('resultadoDemarcacoesPesquisa') ?? ''
      )
    }
    if (results) {
      const ids: number[] = []
      results.forEach((element: any) => {
        ids.push(element.id)
      })

      let file: any;
      if (selected == PROCESSO) {
        filePath = 'shapeFileDhProcessos.zip';
        file = await getShapeFileProcesso(ids);
      } else if (selected == PATRIMONIO) {
        filePath = 'shapeFileDhPatrimonios.zip';
        file = await getShapeFilePatrimonio(ids);
      } else if (selected == DEMARCACAO) {
        filePath = 'shapeFileDhDemarcacoes.zip';
        file = await getShapeFileDemarcacao(ids);
      }

      handleDownload(file, filePath);
  }
}
} 

const onItemClickImprimir = async (event: any) => {
  //exportPDF();
openPdfNewTab();
}

const onItemClickExportarFichasProcesso = async () => {
  try {
    
    const results = JSON.parse(
      SessionStorageService.getItem('resultadoProcessosPesquisa') ?? ''
    );

    const idsProcesso = results.map((o: any) => o.id);

    if (idsProcesso.length > RECORDS_LIMIT) {
      postMessage({ type: 'errorMsg', value: { message: "Não é possivel exportar mais de 100 fichas" } }, '*');
      return false;
    }

    const tabelaAutosVertices = await getListAutosVertices(idsProcesso);
    const tabelaAutos = await getListAutos(idsProcesso);

    const tabelaDados = tabelaAutos.map((auto : any)=> {
      const vertices = tabelaAutosVertices
          .filter((v : any) => v.id_dh_auto === auto.id)
          .map((vertice : any) => ({
              'ID dhAuto': auto.id,
              'Tipo de Domínio': auto.dhTipoDominio?.descricao == 'Domínio Público Hídrico (DPH)' ? 'DPH' :
                                auto.dhTipoDominio?.descricao == 'Domínio Privado do Estado (DPE)' ? 'DPE' :
                                auto.dhTipoDominio?.descricao ?? '',             
               'Número do Diário da República': auto.referencia ?? '',
              'Indice Vértice': vertice.indice ?? '',
              'Longitude X': vertice.lon_x_auto,
              'Latitude Y': vertice.lat_y_auto,
              'Longitude X corrigida' : vertice.lon_x_corrigida ?? '',
              'Latitude Y corrigida' : vertice.lat_y_corrigida ?? ''
          }));
      
      if (vertices.length === 0) {
          return [{
              'ID de dhAuto': '',
              'Tipo de Domínio': '',
              'Número do Diário da República': '',
              'Indice Vértice': '',
              'Longitude X' : '',
              'Latitude Y': '',
              'Longitude X corrigida' : '',
              'Latitude Y corrigida' : ''
          }];
      }

      return vertices;
  }).flat();

  console.log("tabelaDados")
  console.log(tabelaDados)

          
    const dadosProcessos = [];

    const processos = await getProcessoPorIds(idsProcesso);

    for (const processoId of idsProcesso) {

      const processo = processos.find((processo: any) => processo.id === processoId);
      const TipoProcesso = processo?.dhTipoProcesso?.id
      const ResultEntidade = await getEntidadeByUser(processo?.utilizador?.id);

      
    const objToSendImgMapa : any = {
      CodPrintTemplate: "RELATORIO_DH_PROCESSO",
      extendInfo: {
        spatialReference: {
          wkid: 0
        },
        xmin: 0,
        ymin: 0,
        xmax: 0,
        ymax: 0
      },
      ListOperationalLayerInfo: [
        {
          IdOperationLayer: OPERATIONAL_LAYER,
          UseLayerExtent: false,
          DefinitionExpression: "",
          ListServiceLayer: [
            {
                LayerId: LAYER_INDEX_DH_PROCESSO,
                DefinitionExpression: "id=" + processo?.id,
                UseLayerExtent: true
            },
          ]
        }
      ]
    }

      let dados = {};  

      switch (TipoProcesso) {
        case 1:
          dados = {
              // Registo
              'REGISTO': '',
              'Nº Processo APA:': processo?.np_filedoc ?? '',
              'Nº Processo Legado:': processo?.np_legado ?? '',
              'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
              'Técnico:': processo?.utilizador?.userName ?? '',
              'Entidade:' : ResultEntidade?.nome ?? '',

              // Tipologia
              'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',
              'Tipo de iniciativa:': processo?.dhTipoIniciativa?.descricao ?? '',

              // Identificacao
              'Requerente:': processo?.requerente ?? '',
              'Assunto:': processo?.assunto ?? '',
              'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
              'Nº processo CDPM:': processo?.np_cdpm ?? '',
              'Nº Proc Ent.Portuária:': processo?.np_ent_por ?? '',
              'Localização do processo:': processo?.dhLocalizacaoProcesso?.descricao ?? '',
              'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

              // Localizacao
              'Distritos:': processo?.freguesias[0]?.nome ?? '',
              'Concelhos:': processo?.distritos[0]?.nome ?? '',
              'Freguesias:': processo?.freguesias[0]?.nome ?? '',
              'Nuts1:': processo?.nuts1[0]?.nome ?? '',
              'Nuts2:': processo?.nuts2[0]?.nome ?? '',
              'Nuts3:': processo?.nuts3[0]?.nome ?? '',

              // Fase do procedimento
              'Fase de procedimento:': processo?.dhFaseProcedimentoDelimitacao?.descricao ?? '',
              'Representante na comissão delimitação:': processo?.representante ?? '',
              'Observações fase procedimento:': processo?.obs_fase_p ?? '',
              
              // Reconhecimento propriedade privada
              'Reconhecimento de propriedade privada:': processo?.dhReconhecimentoPropriedadePrivada?.descricao ?? '-',
              'Observações reconhecimento propriedade privada:': processo?.obs_rpp ?? '',

              // Auto delimitação
              'Referência:': processo?.dr ?? '',
              'Observações ao auto de delimitação:': processo?.obs_ad ?? '',

               tabelaDados,
              

              // Condicionantes processo
              'Condicionantes processo:': processo?.dhCondicionantesProcesso?.descricao ?? '-',
              'Observações às condicionantes ao procedimento de delimitação:': processo?.obs_condicionantes ?? '',
             
          };
          break;
      
      case 2:
        dados = {
          // Registo
          'REGISTO': '',
          'Nº Processo APA:': processo?.np_filedoc ?? '',
          'Nº Processo Legado:': processo?.np_legado ?? '',
          'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
          'Técnico:': processo?.utilizador?.userName ?? '',
          'Entidade:' : ResultEntidade?.nome ?? '',

          // Tipologia
          'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',
          'Tipo de iniciativa:': processo?.dhTipoIniciativa?.descricao ?? '',

          // Identificacao
          'Requerente:': processo?.requerente ?? '',
          'Assunto:': processo?.assunto ?? '',
          'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
          'Nº processo CDPM:': processo?.np_cdpm ?? '',
          'Localização do processo:': processo?.dhLocalizacaoProcesso?.descricao ?? '',
          'Diário da república:': processo?.dr ?? '',
          'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

          // Localizacao
          'Distritos:': processo?.freguesias[0]?.nome ?? '',
          'Concelhos:': processo?.distritos[0]?.nome ?? '',
          'Freguesias:': processo?.freguesias[0]?.nome ?? '',
          'Nuts1:': processo?.nuts1[0]?.nome ?? '',
          'Nuts2:': processo?.nuts2[0]?.nome ?? '',
          'Nuts3:': processo?.nuts3[0]?.nome ?? '',
          
          // Fase do procedimento
          'Fase de procedimento:': processo?.dhFaseProcedimentoDelimitacao?.descricao ?? '',
          'Representante na comissão delimitação:': processo?.representante ?? '',
          'Observações fase procedimento:': processo?.obs_fase_p ?? '',
          
          // Reconhecimento propriedade privada
          'Reconhecimento de propriedade privada:': processo?.dhReconhecimentoPropriedadePrivada?.descricao ?? '',
          'Observações reconhecimento propriedade privada:': processo?.obs_rpp ?? '',

          // Auto delimitação
          'Observações ao auto de delimitação:': processo?.obs_ad ?? '-',
          'Referência:': processo?.dr ?? '',

          tabelaDados

       
      };
          break;

      case 3:
          dados = {
          // Registo
          'REGISTO': '',
          'Nº Processo APA:': processo?.np_filedoc ?? '',
          'Nº Processo Legado:': processo?.np_legado ?? '',
          'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
          'Técnico:': processo?.utilizador?.userName ?? '',
          'Entidade:' : ResultEntidade?.nome ?? '',

          // Tipologia
          'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',
          'Tipo de acao judicial:': processo?.id_tipo_aj?.descricao ?? '',

          // Identificacao
          'Requerente:': processo?.requerente ?? '',
          'Assunto:': processo?.assunto ?? '',
          'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
          'Nº processo administrativo:': processo?.np_mp ?? '',
          'Nº processo tribunal:': processo?.np_comum ?? '',
          'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

          // Localizacao
          'Distritos:': processo?.freguesias[0]?.nome ?? '',
          'Concelhos:': processo?.distritos[0]?.nome ?? '',
          'Freguesias:': processo?.freguesias[0]?.nome ?? '',
          'Nuts1:': processo?.nuts1[0]?.nome ?? '',
          'Nuts2:': processo?.nuts2[0]?.nome ?? '',
          'Nuts3:': processo?.nuts3[0]?.nome ?? '',

          // Decisão
          'Decisão final:': processo?.dhTipoDecisaoFinal?.descricao ?? '',
          'Sentença:': processo?.id_tipo_se?.descricao ?? '',
          'Observações da sentença:': processo?.obs_senten ?? '',
          'Recurso:': processo?.id_tipo_ac?.descricao ?? '',
          'Observações do recurso:': processo?.obs_acorda?? '',
        
          };
          break;

        case 4:
          dados = {
          // Registo
          'REGISTO': '',
          'Nº Processo APA:': processo?.np_filedoc ?? '',
          'Nº Processo Legado:': processo?.np_legado ?? '',
          'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
          'Técnico:': processo?.utilizador?.userName ?? '',
          'Entidade:' : ResultEntidade?.nome ?? '',

          // Tipologia
          'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',

          // Identificacao
          'Requerente:': processo?.requerente ?? '',
          'Assunto:': processo?.assunto ?? '',
          'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
          'Localização do processo:': processo?.dhLocalizacaoProcesso?.descricao ?? '',
          'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

          // Localizacao
          'Distritos:': processo?.freguesias[0]?.nome ?? '',
          'Concelhos:': processo?.distritos[0]?.nome ?? '',
          'Freguesias:': processo?.freguesias[0]?.nome ?? '',
          'Nuts1:': processo?.nuts1[0]?.nome ?? '',
          'Nuts2:': processo?.nuts2[0]?.nome ?? '',
          'Nuts3:': processo?.nuts3[0]?.nome ?? '',
        
          };
          break;

          case 5:
            dados = {
            // Registo
            'REGISTO': '',
            'Nº Processo APA:': processo?.np_filedoc ?? '',
            'Nº Processo Legado:': processo?.np_legado ?? '',
            'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
            'Técnico:': processo?.utilizador?.userName ?? '',
            'Entidade:' : ResultEntidade?.nome ?? '',

            // Tipologia
            'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',
            'Tipo de aquisicao:': processo?.id_tipo_aq?.descricao ?? '',

            // Identificacao
            'Requerente:': processo?.requerente ?? '',
            'Assunto:': processo?.assunto ?? '',
            'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
            'Localização do processo:': processo?.dhLocalizacaoProcesso?.descricao ?? '',
            'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

            // Localizacao
            'Distritos:': processo?.freguesias[0]?.nome ?? '',
            'Concelhos:': processo?.distritos[0]?.nome ?? '',
            'Freguesias:': processo?.freguesias[0]?.nome ?? '',
            'Nuts1:': processo?.nuts1[0]?.nome ?? '',
            'Nuts2:': processo?.nuts2[0]?.nome ?? '',
            'Nuts3:': processo?.nuts3[0]?.nome ?? '',

            };
            break;

            case 6 :
              dados = {
              // Registo
              'REGISTO': '',
              'Nº Processo APA:': processo?.np_filedoc ?? '',
              'Nº Processo Legado:': processo?.np_legado ?? '',
              'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
              'Técnico:': processo?.utilizador?.userName ?? '',
              'Entidade:' : ResultEntidade?.nome ?? '',
  
              // Tipologia
              'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',

              // Identificacao
              'Requerente:': processo?.requerente ?? '',
              'Assunto:': processo?.assunto ?? '',
              'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
              'Nº processo CDPM:': processo?.np_cdpm ?? '',            
              'Localização do processo:': processo?.dhLocalizacaoProcesso?.descricao ?? '',
              'Observações do estado do processo:': processo?.obs_tipo_e ?? '',
                   
              // Localizacao
              'Distritos:': processo?.freguesias[0]?.nome ?? '',
              'Concelhos:': processo?.distritos[0]?.nome ?? '',
              'Freguesias:': processo?.freguesias[0]?.nome ?? '',
              'Nuts1:': processo?.nuts1[0]?.nome ?? '',
              'Nuts2:': processo?.nuts2[0]?.nome ?? '',
              'Nuts3:': processo?.nuts3[0]?.nome ?? '',

               // Reconhecimento propriedade privada
              'Reconhecimento de propriedade privada:': processo?.dhReconhecimentoPropriedadePrivada?.descricao ?? '',
              'Observações reconhecimento propriedade privada:': processo?.obs_rpp ?? '',

              // Outros critérios
              'Deferimento de licenciamento:' : processo?.dhDefLicenciamentos?.descricao ?? ''
            
              };
              break;

              case 7 :
                dados = {
                // Registo
                'REGISTO': '',
                'Nº Processo APA:': processo?.np_filedoc ?? '',
                'Nº Processo Legado:': processo?.np_legado ?? '',
                'Data do registo:': processo? new Date(processo?.data_registo).toLocaleDateString() : '',
                'Técnico:': processo?.utilizador?.userName ?? '',
                'Entidade:' : ResultEntidade?.nome ?? '',
    
                // Tipologia
                'Tipo de processo:': processo?.dhTipoProcesso?.descricao ?? '',
  
                // Identificacao
                'Requerente:': processo?.requerente ?? '',
                'Assunto:': processo?.assunto ?? '',
                'Estado do processo:': processo?.dhEstadoProcesso?.descricao ?? '',
                'Nº registo SGD:': processo?.num_doc ?? '',            
                'Observações do estado do processo:': processo?.obs_tipo_e ?? '',

                     
                // Localizacao
                'Distritos:': processo?.freguesias[0]?.nome ?? '',
                'Concelhos:': processo?.distritos[0]?.nome ?? '',
                'Freguesias:': processo?.freguesias[0]?.nome ?? '',
                'Nuts1:': processo?.nuts1[0]?.nome ?? '',
                'Nuts2:': processo?.nuts2[0]?.nome ?? '',
                'Nuts3:': processo?.nuts3[0]?.nome ?? '',

                };
                break;

      default:
          console.log("Tipo de processo desconhecido.");
          return;
        
      }

      dadosProcessos.push({
        id: processoId,
        dados: dados,
        img_mapa: "",
        tipoRelatorio: TipoProcesso ,
        objJsonToCreateImg: objToSendImgMapa,
      });
    }
    postMessage({ type: 'showLoader' }, '*')

    const mergedPdfBase64 = await relatorioProcessoMerge(dadosProcessos);  

    if (mergedPdfBase64) {
      const blob = b64toBlob(mergedPdfBase64, 'application/pdf');
      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
    }

  } catch (error) {
    console.log(error);
    postMessage({ type: 'errorMsg', value: { left: '50%', message: "Verifique os campos obrigatórios." } }, '*');
  } finally {
    postMessage({ type: 'hideLoader' }, '*');
  }
};


const openPdfNewTab = () => {
  return new Promise<void>((resolve, reject) => {
      
      postMessage({ type: "showLoader" }, "*");

      setTimeout(() => {
         let columnsToShow: any; 
         let results;
         if (selected == PROCESSO) {
          columnsToShow = columnsProcessoGrid.columns.filter((x: { show: any }) => x.show);
          results = JSON.parse(SessionStorageService.getItem("resultadoProcessosPesquisa") ?? '')
         }
         if (selected == PATRIMONIO) {
          columnsToShow = columnsPatrimonioGrid.columns.filter((x: { show: any }) => x.show);
          results = JSON.parse(SessionStorageService.getItem("resultadoPatrimoniosPesquisa") ?? '');
         }
         if (selected == DEMARCACAO) {
          columnsToShow = columnsDemarcacaoGrid.columns.filter((x: { show: any }) => x.show);
          results = JSON.parse(SessionStorageService.getItem("resultadoDemarcacoesPesquisa") ?? '')
         }

         const dataToExport = results?.map((item: any) => {
          const filteredItem: any = {};
          columnsToShow.forEach((column: any) => {
              if (column.field.indexOf(".") != -1) {
                const textArr = column.field.split(".");
                const fieldString = textArr[0];
                const valueString = textArr[1];
                if (valueString) {
                  filteredItem[column.field] = item[fieldString][valueString];
                }
              } else {
              filteredItem[column.field] = item[column.field];
            }
          });
          return filteredItem;
          });
          
          exportPDFWithMethod(columnsToShow, dataToExport, 8)
              .then((pdfData: any) => {
                  postMessage({ type: "hideLoader" }, "*");

                      const base64Data = pdfData.split(";base64,")[1];
                      console.log(base64Data);
                      const blob = b64toBlob(base64Data, 'application/pdf');
                      const blobUrl = URL.createObjectURL(blob);

                    
                      window.open(blobUrl, '_blank');
                      resolve();
                
              })
              .catch(error => {
                  console.error('Error exporting PDF:', error);
                  reject(error);
              });
      }, 1000);
  });
};

const itemRender = (props: { item: any; itemIndex: number }) => {
  const isTitleItem = props.item.key === 'titulo';
  if (isTitleItem) {
      // Item de título personalizado
      return (
          <div className={styles.DropDownButtonTitulo}>
              <span>{props.item.text}</span>
          </div>
      );
  } else {
      // Demais itens
      return (
          <div className={styles.DropDownButtonItem}>
              <span>{props.item.text}</span>
          </div>
      );
  }
};

const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

const resultadosDisponiveis = (selected === 0 && SessionStorageService.getItem("resultadoProcessosPesquisa")) || (selected === 1 && SessionStorageService.getItem("resultadoPatrimoniosPesquisa")) || (selected === 2 && SessionStorageService.getItem("resultadoDemarcacoesPesquisa"));

  return (
    <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
      <div className={styles.header}>
        <div>
          <div className={styles.nomeDoModulo}>Domínio Hídrico</div>
          <div className={styles.tituloDaPagina}>Pesquisa</div>
        </div>

        <div>
          { canSeeDominioHidricoEdit && !someNewButton &&
            <Button
              onClick={handleNewRegistoClick}
              className={styles.btnNovoRegisto}
              style={{ display: isMobile ? 'none' : '' }}
              id='novoRegisto'
              title={newRegistoLabel}
            >
              <span className="icon-siarl icon-registar btnIconRegistar" /> &nbsp;{' '}
              {newRegistoLabel}
            </Button>
          }
          {isMobile &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

            {(!isMobile && selected == PROCESSO && showExportButtons && SessionStorageService.getItem("resultadoProcessosPesquisa")) ?
                <><VisualizadorColunas
              columns={columnsProcesso}
              setColumns={setColumnsProcesso}
              styles={styles.btnEditar2} />
              
              {showExportButtons ? 
              <button className={styles.btnEditar2} onClick={exportPDF} title='Imprimir'>
                <span className="icon-siarl icon-imprimir"></span>
              </button> : ''}
              {showExportButtons ? 
              <DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                itemRender={itemRender}
                title='Exportar'
              ></DropDownButton>
              : '' }
              </>
                : <></>
            }

            {(!isMobile && selected == PATRIMONIO && showExportButtons && SessionStorageService.getItem("resultadoPatrimoniosPesquisa")) ?
                <><VisualizadorColunas
              columns={columnsPatrimonio}
              setColumns={setColumnsPatrimonio}
              styles={styles.btnEditar2} />
              
              <button className={styles.btnEditar2} onClick={exportPDF} title='Imprimir'>
              <span className="icon-siarl icon-imprimir"></span>
              </button>
              <DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                itemRender={itemRender}
                title='Exportar'
              ></DropDownButton></>
                : <></>
            }

            {(!isMobile && selected == DEMARCACAO && showExportButtons && SessionStorageService.getItem("resultadoDemarcacoesPesquisa")) ?
                <><VisualizadorColunas
              columns={columnsDemarcacao}
              setColumns={setColumnsDemarcacao}
              styles={styles.btnEditar2} />
              
              <button className={styles.btnEditar2} onClick={exportPDF} title='Imprimir'>
                <span className="icon-siarl icon-imprimir"></span>
              </button>
              <DropDownButton
                items={optionsExportar}
                className={styles.btnImprimir}
                style={{ marginTop: '-4px' }}
                iconClass="icon-siarl icon-exportar"
                onItemClick={onItemClickExportar}
                fillMode={'flat'}
                itemRender={itemRender}
                title='Exportar'
              ></DropDownButton></>
                : <></>
            }
            

            {isMobile &&
              <DropDownButton
                items={optionsMais}
                className={styles.btnMais}
                iconClass="icon-siarl icon-mais"
                onItemClick={onItemClickMais}
                fillMode={'flat'}
                itemRender={itemRenderMais}
                title="Mais Opções"
              />
            }

            <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
              <span className="icon-siarl icon-ajuda"></span>
            </button>

            <button className={styles.btnFechar} onClick={onCloseClick} title="Minimizar">
              <span className="icon-siarl icon-minimizar"></span>
            </button>

            
          {!isMobile && resultadosDisponiveis && (
            <MaximizeButton className={styles.btnMaximizar} />
          )}

        </div>
      </div>
      <TabStrip selected={selected} className="backgroundWhite" onSelect={handleSelect}
      scrollable={isMobile}>
        {seeProcesso || canSeeDominioHidrico ? 
        <TabStripTab title="Processos" key="Processos">
          {SessionStorageService.getItem("resultadoProcessosPesquisa") ? 
            <ResultadoProcessoForm secondShowTab={secondShowTab} setSecondShowTab={setSecondShowTab} columns={columnsProcessoGrid} setColumns={setColumnsProcessoGrid} columnsDocuments={columsDocumentsProcesso} setColumnsDocuments={setColumsDocumentsProcesso} onCloseClick={onCloseClick} setShowResults={setShowResultadoProcesso} columnsPrint={columnsProcessoGrid} setColumnsPrint={setColumnsProcessoGrid}></ResultadoProcessoForm>
          :
            <PesquisarProcessoForm onCloseClick={onCloseClick} />
          }
        </TabStripTab>
        : ''}
        {seePatrimonio || canSeeDominioHidrico ? 
        <TabStripTab title="Património"  key="Património">
          {SessionStorageService.getItem("resultadoPatrimoniosPesquisa") ? 
            <ResultadoPatrimonioForm onCloseClick={onCloseClick} columnsDocuments={columsDocumentsPatrimonio} setColumnsDocuments={setColumsDocumentsPatrimonio} setShowResults={setShowResultadoPatrimonio} columns={columnsPatrimonioGrid} setColumns={setColumnsPatrimonioGrid} columnsPrint={columnsPatrimonioGrid} setColumnsPrint={setColumnsPatrimonioGrid} ></ResultadoPatrimonioForm>
          :
            <PesquisarPatrimonioForm onClick={removeSessionPatrimonio} />
          }
        </TabStripTab>
        : ''}
        {/* {seeDemarcacao || canSeeDominioHidrico ? 
        <TabStripTab title="Demarcações"  key="Demarcação">
          {SessionStorageService.getItem("resultadoDemarcacoesPesquisa") ? 
            <ResultadoDemarcacaoForm onCloseClick={onCloseClick} columnsDocuments={columsDocumentsDemarcacao} setColumnsDocuments={setColumsDocumentsDemarcacao} setShowResults={setShowResultadoDemarcacao} columns={columnsDemarcacaoGrid} setColumns={setColumnsDemarcacaoGrid} columnsPrint={columnsDemarcacaoGrid} setColumnsPrint={setColumnsDemarcacaoGrid}></ResultadoDemarcacaoForm>
          :
            <PesquisarDemarcacaoForm  onClick={removeSessionDemarcacao}/>
          }
        </TabStripTab>
        : ''} */}
      </TabStrip>
    </div>
  )
}
